import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { cardSurchargePercentFromSettings } from "../../supabase/functions/_shared/square-order-body.ts";

// The card fee percent the payment links charge (#982), read from app_settings
// so a manually recorded card payment can be split into net + fee (#1138).
// No staleTime: it refetches each time the dialog opens, so a changed setting
// is picked up without a reload.
export function useCardSurchargePercent(enabled: boolean) {
  const { data, status } = useQuery({
    queryKey: ["app_settings", "card_surcharge"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("app_settings")
        .select("key, value")
        .in("key", ["cc_surcharge_enabled", "cc_surcharge_percent"]);
      if (error) throw error;
      const map: Record<string, string> = {};
      for (const row of data ?? []) map[row.key] = row.value;
      return cardSurchargePercentFromSettings(map.cc_surcharge_enabled, map.cc_surcharge_percent);
    },
    enabled,
  });
  return { percent: data ?? 0, status };
}
